import { useEffect } from 'react';
import { useStore } from '@/legacy/store/zustand';
import { TABLE_PARAM_KEY } from '@/legacy/constants';

export const LAST_CLEANUP_DATE_KEY = 'filter_cleanup_date';

const clearTableStorage = () => {
	const prefix = TABLE_PARAM_KEY('');
	Object.keys(localStorage)
		.filter((key) => key.startsWith(prefix))
		.forEach((key) => localStorage.removeItem(key));
};

const performCleanup = (resetPageSlice: () => void) => {
	resetPageSlice();
	clearTableStorage();
	localStorage.setItem(LAST_CLEANUP_DATE_KEY, new Date().toDateString());
};

export const useFIlterReset = () => {
	const resetPageSlice = useStore((state) => state.resetPageSlice);

	useEffect(() => {
		// On mount: reset filters if the date has changed since the last cleanup.
		// This ensures stale stored dates from a previous day are never used.
		const lastCleanup = localStorage.getItem(LAST_CLEANUP_DATE_KEY);
		if (lastCleanup !== new Date().toDateString()) {
			performCleanup(resetPageSlice);
		}

		// Also reset at midnight so filters never go stale during a long session.
		const now = new Date();
		const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
		const msToMidnight = midnight.getTime() - now.getTime();

		const timer = setTimeout(() => {
			performCleanup(resetPageSlice);
		}, msToMidnight);

		return () => clearTimeout(timer);
	}, [resetPageSlice]);
};
